import React from 'react';
import { Link } from 'react-router-dom';
import SidebarLeftOne from '../../elements/SidebarLeftOne';

const AttorneyLeftSidebarThreeGridSectionOne = () => {
    return(
        <>
        {/*Our Attorneys Section*/}
        <section className="our-attorneys-sections-nobg section-padding-default">
            <div className="default-container">
            <div className="row clearfix">
                <div className="col-lg-8 order-md-2">
                <div className="row clearfix">
                    <div className="col-lg-4 mb-5">
                    <div className="attorney-box text-center">
                        <div className="attorney-img">
                        <img src="images/attorneys/at-01-255x330.png" alt="" className="img-fluid mx-auto d-block" />
                        </div>
                        <div className="attorney-social-details">
                        <div className="mt-3">
                            <h6 className="mb-0 font-weight-bold"><Link to="/attorney-single-1">john denver</Link></h6>
                            <p className="attorney-work">Corporate Lawyer</p>
                        </div>
                        <ul className="list-inline mb-0 text-center">
                            <li className="list-inline-item"><Link to="#" className><i className="fa fa-facebook" /></Link></li>
                            <li className="list-inline-item"><Link to="#" className><i className="fa fa-instagram" /></Link></li>
                            <li className="list-inline-item"><Link to="#"><i className="fa fa-pinterest-p" /></Link></li>
                            <li className="list-inline-item"><Link to="#"><i className="fa fa-linkedin" /></Link></li>
                        </ul>
                        </div>
                    </div>
                    </div>
                    <div className="col-lg-4 mb-5">
                    <div className="attorney-box text-center">
                        <div className="attorney-img">
                        <img src="images/attorneys/at-02-255x330.png" alt="" className="img-fluid mx-auto d-block" />
                        </div>
                        <div className="attorney-social-details">
                        <div className="mt-3">
                            <h6 className="mb-0 font-weight-bold"><Link to="/attorney-single-1">john denver</Link></h6>
                            <p className="attorney-work">Corporate Lawyer</p>
                        </div>
                        <ul className="list-inline mb-0 text-center">
                            <li className="list-inline-item"><Link to="#" className><i className="fa fa-facebook" /></Link></li>
                            <li className="list-inline-item"><Link to="#" className><i className="fa fa-instagram" /></Link></li>
                            <li className="list-inline-item"><Link to="#"><i className="fa fa-pinterest-p" /></Link></li>
                            <li className="list-inline-item"><Link to="#"><i className="fa fa-linkedin" /></Link></li>
                        </ul>
                        </div>
                    </div>
                    </div>
                    <div className="col-lg-4 mb-5">
                    <div className="attorney-box text-center">
                        <div className="attorney-img">
                        <img src="images/attorneys/at-03-255x330.png" alt="" className="img-fluid mx-auto d-block" />
                        </div>
                        <div className="attorney-social-details">
                        <div className="mt-3">
                            <h6 className="mb-0 font-weight-bold"><Link to="/attorney-single-1">john denver</Link></h6>
                            <p className="attorney-work">Corporate Lawyer</p>
                        </div>
                        <ul className="list-inline mb-0 text-center">
                            <li className="list-inline-item"><Link to="#" className><i className="fa fa-facebook" /></Link></li>
                            <li className="list-inline-item"><Link to="#" className><i className="fa fa-instagram" /></Link></li>
                            <li className="list-inline-item"><Link to="#"><i className="fa fa-pinterest-p" /></Link></li>
                            <li className="list-inline-item"><Link to="#"><i className="fa fa-linkedin" /></Link></li>
                        </ul>
                        </div>
                    </div>
                    </div>
                    <div className="col-lg-4 mb-5">
                    <div className="attorney-box text-center">
                        <div className="attorney-img">
                        <img src="images/attorneys/at-04-255x330.png" alt="" className="img-fluid mx-auto d-block" />
                        </div>
                        <div className="attorney-social-details">
                        <div className="mt-3">
                            <h6 className="mb-0 font-weight-bold"><Link to="/attorney-single-1">john denver</Link></h6>
                            <p className="attorney-work">Corporate Lawyer</p>
                        </div>
                        <ul className="list-inline mb-0 text-center">
                            <li className="list-inline-item"><Link to="#" className><i className="fa fa-facebook" /></Link></li>
                            <li className="list-inline-item"><Link to="#" className><i className="fa fa-instagram" /></Link></li>
                            <li className="list-inline-item"><Link to="#"><i className="fa fa-pinterest-p" /></Link></li>
                            <li className="list-inline-item"><Link to="#"><i className="fa fa-linkedin" /></Link></li>
                        </ul>
                        </div>
                    </div>
                    </div>
                    <div className="col-lg-4 mb-5">
                    <div className="attorney-box text-center">
                        <div className="attorney-img">
                        <img src="images/attorneys/at-05-255x330.png" alt="" className="img-fluid mx-auto d-block" />
                        </div>
                        <div className="attorney-social-details">
                        <div className="mt-3">
                            <h6 className="mb-0 font-weight-bold"><Link to="/attorney-single-1">john denver</Link></h6>
                            <p className="attorney-work">Corporate Lawyer</p>
                        </div>
                        <ul className="list-inline mb-0 text-center">
                            <li className="list-inline-item"><Link to="#" className><i className="fa fa-facebook" /></Link></li>
                            <li className="list-inline-item"><Link to="#" className><i className="fa fa-instagram" /></Link></li>
                            <li className="list-inline-item"><Link to="#"><i className="fa fa-pinterest-p" /></Link></li>
                            <li className="list-inline-item"><Link to="#"><i className="fa fa-linkedin" /></Link></li>
                        </ul>
                        </div>
                    </div>
                    </div>
                    <div className="col-lg-4 mb-5">
                    <div className="attorney-box text-center">
                        <div className="attorney-img">
                        <img src="images/attorneys/at-06-255x330.png" alt="" className="img-fluid mx-auto d-block" />
                        </div>
                        <div className="attorney-social-details">
                        <div className="mt-3">
                            <h6 className="mb-0 font-weight-bold"><Link to="/attorney-single-1">john denver</Link></h6>
                            <p className="attorney-work">Corporate Lawyer</p>
                        </div>
                        <ul className="list-inline mb-0 text-center">
                            <li className="list-inline-item"><Link to="#" className><i className="fa fa-facebook" /></Link></li>
                            <li className="list-inline-item"><Link to="#" className><i className="fa fa-instagram" /></Link></li>
                            <li className="list-inline-item"><Link to="#"><i className="fa fa-pinterest-p" /></Link></li>
                            <li className="list-inline-item"><Link to="#"><i className="fa fa-linkedin" /></Link></li>
                        </ul>
                        </div>
                    </div>
                    </div>
                    <div className="col-lg-4 mb-5">
                    <div className="attorney-box text-center">
                        <div className="attorney-img">
                        <img src="images/attorneys/at-07-255x330.png" alt="" className="img-fluid mx-auto d-block" />
                        </div>
                        <div className="attorney-social-details">
                        <div className="mt-3">
                            <h6 className="mb-0 font-weight-bold"><Link to="/attorney-single-1">john denver</Link></h6>
                            <p className="attorney-work">Corporate Lawyer</p>
                        </div>
                        <ul className="list-inline mb-0 text-center">
                            <li className="list-inline-item"><Link to="#" className><i className="fa fa-facebook" /></Link></li>
                            <li className="list-inline-item"><Link to="#" className><i className="fa fa-instagram" /></Link></li>
                            <li className="list-inline-item"><Link to="#"><i className="fa fa-pinterest-p" /></Link></li>
                            <li className="list-inline-item"><Link to="#"><i className="fa fa-linkedin" /></Link></li>
                        </ul>
                        </div>
                    </div>
                    </div>
                    <div className="col-lg-4 mb-5">
                    <div className="attorney-box text-center">
                        <div className="attorney-img">
                        <img src="images/attorneys/at-08-255x330.png" alt="" className="img-fluid mx-auto d-block" />
                        </div>
                        <div className="attorney-social-details">
                        <div className="mt-3">
                            <h6 className="mb-0 font-weight-bold"><Link to="/attorney-single-1">john denver</Link></h6>
                            <p className="attorney-work">Corporate Lawyer</p>
                        </div>
                        <ul className="list-inline mb-0 text-center">
                            <li className="list-inline-item"><Link to="#" className><i className="fa fa-facebook" /></Link></li>
                            <li className="list-inline-item"><Link to="#" className><i className="fa fa-instagram" /></Link></li>
                            <li className="list-inline-item"><Link to="#"><i className="fa fa-pinterest-p" /></Link></li>
                            <li className="list-inline-item"><Link to="#"><i className="fa fa-linkedin" /></Link></li>
                        </ul>
                        </div>
                    </div>
                    </div>
                    <div className="col-lg-4 mb-5">
                    <div className="attorney-box text-center">
                        <div className="attorney-img">
                        <img src="images/attorneys/at-09-255x330.png" alt="" className="img-fluid mx-auto d-block" />
                        </div>
                        <div className="attorney-social-details">
                        <div className="mt-3">
                            <h6 className="mb-0 font-weight-bold"><Link to="/attorney-single-1">john denver</Link></h6>
                            <p className="attorney-work">Corporate Lawyer</p>
                        </div>
                        <ul className="list-inline mb-0 text-center">
                            <li className="list-inline-item"><Link to="#" className><i className="fa fa-facebook" /></Link></li>
                            <li className="list-inline-item"><Link to="#" className><i className="fa fa-instagram" /></Link></li>
                            <li className="list-inline-item"><Link to="#"><i className="fa fa-pinterest-p" /></Link></li>
                            <li className="list-inline-item"><Link to="#"><i className="fa fa-linkedin" /></Link></li>
                        </ul>
                        </div>
                    </div>
                    </div>
                    <div className="col-lg-4 mb-5">
                    <div className="attorney-box text-center">
                        <div className="attorney-img">
                        <img src="images/attorneys/at-01-255x330.png" alt="" className="img-fluid mx-auto d-block" />
                        </div>
                        <div className="attorney-social-details">
                        <div className="mt-3">
                            <h6 className="mb-0 font-weight-bold"><Link to="/attorney-single-1">john denver</Link></h6>
                            <p className="attorney-work">Corporate Lawyer</p>
                        </div>
                        <ul className="list-inline mb-0 text-center">
                            <li className="list-inline-item"><Link to="#" className><i className="fa fa-facebook" /></Link></li>
                            <li className="list-inline-item"><Link to="#" className><i className="fa fa-instagram" /></Link></li>
                            <li className="list-inline-item"><Link to="#"><i className="fa fa-pinterest-p" /></Link></li>
                            <li className="list-inline-item"><Link to="#"><i className="fa fa-linkedin" /></Link></li>
                        </ul>
                        </div>
                    </div>
                    </div>
                    <div className="col-lg-4 mb-5">
                    <div className="attorney-box text-center">
                        <div className="attorney-img">
                        <img src="images/attorneys/at-02-255x330.png" alt="" className="img-fluid mx-auto d-block" />
                        </div>
                        <div className="attorney-social-details">
                        <div className="mt-3">
                            <h6 className="mb-0 font-weight-bold"><Link to="/attorney-single-1">john denver</Link></h6>
                            <p className="attorney-work">Corporate Lawyer</p>
                        </div>
                        <ul className="list-inline mb-0 text-center">
                            <li className="list-inline-item"><Link to="#" className><i className="fa fa-facebook" /></Link></li>
                            <li className="list-inline-item"><Link to="#" className><i className="fa fa-instagram" /></Link></li>
                            <li className="list-inline-item"><Link to="#"><i className="fa fa-pinterest-p" /></Link></li>
                            <li className="list-inline-item"><Link to="#"><i className="fa fa-linkedin" /></Link></li>
                        </ul>
                        </div>
                    </div>
                    </div>
                    <div className="col-lg-4 mb-5">
                    <div className="attorney-box text-center">
                        <div className="attorney-img">
                        <img src="images/attorneys/at-03-255x330.png" alt="" className="img-fluid mx-auto d-block" />
                        </div>
                        <div className="attorney-social-details">
                        <div className="mt-3">
                            <h6 className="mb-0 font-weight-bold"><Link to="/attorney-single-1">john denver</Link></h6>
                            <p className="attorney-work">Corporate Lawyer</p>
                        </div>
                        <ul className="list-inline mb-0 text-center">
                            <li className="list-inline-item"><Link to="#" className><i className="fa fa-facebook" /></Link></li>
                            <li className="list-inline-item"><Link to="#" className><i className="fa fa-instagram" /></Link></li>
                            <li className="list-inline-item"><Link to="#"><i className="fa fa-pinterest-p" /></Link></li>
                            <li className="list-inline-item"><Link to="#"><i className="fa fa-linkedin" /></Link></li>
                        </ul>
                        </div>
                    </div>
                    </div>
                    <div className="col-lg-12">
                    <ul className="cr-pagination-center">
                        <li><Link to="#" title><i className="fa fa-angle-left" /></Link></li>
                        <li className="active"><Link to="#" title>1</Link></li>
                        <li><Link to="#" title>2</Link></li>
                        <li><Link to="#" title>3</Link></li>
                        <li><Link to="#" title><i className="fa fa-angle-right" /></Link></li>
                    </ul>
                    </div>
                </div>
                </div>
                
                <SidebarLeftOne />
                
            </div>
            </div>
        </section>
        {/* End Our Attorneys Section */}
        </>
    )
}

export default AttorneyLeftSidebarThreeGridSectionOne;